import { UserTicketDanceRoleTypeEnum } from '../../enums';

export interface TicketSaleQuantityInformationInterface {
  ticketId: string;
  ticketName: string;
  boughtQuantity: number;
  checkedInQuantity: number;
  danceRoleType: UserTicketDanceRoleTypeEnum;
}
